/**
 * Модуль записи на приём к психологу
 * Пошаговый процесс: Формат → Дата → Время → Подтверждение → Авторизация (если нужна) → Запись
 */
const Booking = {
	// ID модуля для AJAX
	moduleId: 2,

	// Текущий шаг (1, 2, 3, 4)
	currentStep: 1,

	// Выбранные данные
	data: {
		personId: null,
		personName: '',
		personPhoto: '',
		serviceId: null,
		serviceName: '',
		servicePrice: 0,
		serviceDuration: 60,
		format: null, // Шаг 1
		date: null,   // Шаг 2
		dateFormatted: '',
		timeStart: null, // Шаг 3
		timeEnd: null,
		price: 0
	},

	// Доступные слоты
	availableDates: [],
	availableSlots: [],

	// Количество слотов по форматам
	formatSlots: { online: 0, offline: 0 },

	// Флаг авторизации
	isAuthenticated: false,
	clientId: null,

	/**
	 * Инициализация
	 */
	init: function() {
		// Проверяем авторизацию
		this.checkAuth();

		// Закрытие попапа
		this.initPopupClose();

		// Слушаем выбор формата
		this.initFormatSelection();
	},

	/**
	 * Инициализация выбора формата
	 */
	initFormatSelection: function() {
		document.querySelectorAll('input[name="format"]').forEach(input => {
			input.addEventListener('change', () => {
				this.data.format = input.value;
				document.getElementById('booking-format').value = input.value;
				document.getElementById('booking-btn-next').disabled = false;
			});
		});
	},

	/**
	 * Инициализация закрытия попапа
	 */
	initPopupClose: function() {
		const popup = document.getElementById('popup-booking');
		if (!popup) return;

		// Закрытие по клику на фон
		popup.addEventListener('click', (e) => {
			if (e.target === popup || e.target.classList.contains('popup__wrapper')) {
				this.close();
			}
		});

		// Закрытие по Escape
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && popup.classList.contains('active')) {
				this.close();
			}
		});
	},

	/**
	 * Открытие попапа записи
	 * @param {number} personId - ID психолога
	 * @param {number} serviceId - ID услуги (опционально)
	 */
	open: function(personId, serviceId = null) {
		const popup = document.getElementById('popup-booking');
		if (!popup) return;

		// Сбрасываем состояние
		this.reset();

		// Сохраняем ID
		this.data.personId = personId;
		this.data.serviceId = serviceId;
		document.getElementById('booking-person-id').value = personId;
		if (serviceId) {
			document.getElementById('booking-service-id').value = serviceId;
		}

		// Открываем попап
		popup.classList.add('active');
		document.body.style.overflow = 'hidden';

		// Загружаем данные психолога и счётчики слотов
		this.loadPersonData(personId);
		this.loadFormatSlotsCount(personId);
	},

	/**
	 * Закрытие попапа
	 */
	close: function() {
		const popup = document.getElementById('popup-booking');
		if (popup) {
			popup.classList.remove('active');
			document.body.style.overflow = '';
		}
	},

	/**
	 * Сброс состояния
	 */
	reset: function() {
		this.currentStep = 1;
		this.data = {
			personId: null,
			personName: '',
			personPhoto: '',
			serviceId: null,
			serviceName: '',
			servicePrice: 0,
			serviceDuration: 60,
			format: null,
			date: null,
			dateFormatted: '',
			timeStart: null,
			timeEnd: null,
			price: 0
		};
		this.availableDates = [];
		this.availableSlots = [];

		// Сбрасываем UI
		this.goToStep(1);
		this.clearError();

		// Очищаем контейнеры
		const datesContainer = document.getElementById('booking-dates');
		const timesContainer = document.getElementById('booking-times');
		const notesEl = document.getElementById('booking-notes');
		if (datesContainer) datesContainer.innerHTML = '';
		if (timesContainer) timesContainer.innerHTML = '';
		if (notesEl) notesEl.value = '';

		// Сбрасываем выбор формата
		document.querySelectorAll('input[name="format"]').forEach(input => {
			input.checked = false;
		});
	},

	/**
	 * Проверка авторизации
	 */
	checkAuth: function() {
		// Проверяем наличие данных клиента на странице
		const clientEl = document.querySelector('[data-client-id]');
		if (clientEl) {
			this.isAuthenticated = true;
			this.clientId = clientEl.dataset.clientId;
		} else {
			// Запрашиваем через AJAX
			const formData = new FormData();
			formData.append('mid', this.moduleId);
			formData.append('action', 'check_auth');

			fetch('/ajax.php', {
				method: 'POST',
				body: formData
			})
			.then(response => response.json())
			.then(data => {
				this.isAuthenticated = data.authenticated || false;
				this.clientId = data.client_id || null;
			})
			.catch(() => {
				this.isAuthenticated = false;
			});
		}
	},

	/**
	 * Загрузка данных психолога
	 */
	loadPersonData: function(personId) {
		const formData = new FormData();
		formData.append('mid', this.moduleId);
		formData.append('action', 'get_person');
		formData.append('person_id', personId);

		fetch('/ajax.php', {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			if (data.success && data.person) {
				const p = data.person;
				this.data.personName = p.name;
				this.data.personPhoto = p.photo;
				this.data.serviceDuration = p.session_duration || 60;
				this.data.servicePrice = p.rate_hour || 0;

				// Обновляем UI
				document.getElementById('booking-psy-name').textContent = p.name;
				const photoEl = document.getElementById('booking-psy-photo');
				if (p.photo) {
					photoEl.innerHTML = '<img src="' + p.photo + '" alt="">';
				}

				// Если услуга не выбрана - показываем дефолтную
				if (!this.data.serviceId) {
					this.data.serviceName = 'Индивидуальная консультация';
					this.data.price = this.data.servicePrice;
					document.getElementById('booking-service-name').textContent = this.data.serviceName;
				}
			}
		});
	},

	/**
	 * Загрузка количества слотов по форматам
	 */
	loadFormatSlotsCount: function(personId) {
		var formData = new FormData();
		formData.append('mid', this.moduleId);
		formData.append('action', 'get_format_slots_count');
		formData.append('person_id', personId);

		fetch('/ajax.php', {
			method: 'POST',
			body: formData
		})
		.then(function(response) { return response.json(); })
		.then(function(data) {
			if (data.success) {
				Booking.formatSlots = { online: data.online || 0, offline: data.offline || 0 };
				Booking.updateFormatSlotsUI();
			}
		});
	},

	/**
	 * Обновление UI счётчиков слотов на шаге 1
	 */
	updateFormatSlotsUI: function() {
		var offlineCount = document.getElementById('booking-format-offline-count');
		var onlineCount = document.getElementById('booking-format-online-count');
		var unavailable = document.getElementById('booking-unavailable');

		if (offlineCount) {
			if (this.formatSlots.offline > 0) {
				offlineCount.textContent = this.formatSlots.offline + ' ' + this.pluralize(this.formatSlots.offline, 'слот', 'слота', 'слотов');
			} else {
				offlineCount.textContent = 'нет слотов';
			}
			offlineCount.style.display = '';
		}
		if (onlineCount) {
			if (this.formatSlots.online > 0) {
				onlineCount.textContent = this.formatSlots.online + ' ' + this.pluralize(this.formatSlots.online, 'слот', 'слота', 'слотов');
			} else {
				onlineCount.textContent = 'нет слотов';
			}
			onlineCount.style.display = '';
		}

		// Если нет слотов ни в одном формате
		if (unavailable) {
			if (this.formatSlots.online === 0 && this.formatSlots.offline === 0) {
				unavailable.style.display = '';
				document.getElementById('booking-btn-next').style.display = 'none';
			} else {
				unavailable.style.display = 'none';
			}
		}

		// Блокируем формат без слотов
		var offlineRadio = document.querySelector('input[name="format"][value="офлайн"]');
		var onlineRadio = document.querySelector('input[name="format"][value="онлайн"]');
		if (offlineRadio) {
			offlineRadio.disabled = (this.formatSlots.offline === 0);
			offlineRadio.closest('.popup-booking__format-option').classList.toggle('popup-booking__format-option--disabled', this.formatSlots.offline === 0);
		}
		if (onlineRadio) {
			onlineRadio.disabled = (this.formatSlots.online === 0);
			onlineRadio.closest('.popup-booking__format-option').classList.toggle('popup-booking__format-option--disabled', this.formatSlots.online === 0);
		}
	},

	/**
	 * Загрузка доступных дат с учётом формата
	 */
	loadAvailableDates: function(personId, format) {
		const container = document.getElementById('booking-dates');
		const loading = document.getElementById('booking-dates-loading');

		container.style.display = 'none';
		loading.style.display = 'flex';

		const formData = new FormData();
		formData.append('mid', this.moduleId);
		formData.append('action', 'get_available_dates');
		formData.append('person_id', personId);
		formData.append('format', format);

		fetch('/ajax.php', {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			loading.style.display = 'none';
			container.style.display = '';

			if (data.success && data.dates && data.dates.length > 0) {
				this.availableDates = data.dates;
				this.renderDates(data.dates);
			} else {
				container.innerHTML = '<div class="popup-booking__empty">Нет доступных дат для записи в формате "' + (format === 'онлайн' ? 'онлайн' : 'очно') + '". Попробуйте выбрать другой формат или свяжитесь с нами по телефону.</div>';
			}
		})
		.catch(error => {
			loading.style.display = 'none';
			container.style.display = '';
			container.innerHTML = '<div class="popup-booking__error-message">Ошибка загрузки расписания</div>';
		});
	},

	/**
	 * Отрисовка доступных дат
	 */
	renderDates: function(dates) {
		const container = document.getElementById('booking-dates');
		container.innerHTML = '';

		// Группируем по неделям
		const weeks = {};
		dates.forEach(dateInfo => {
			const date = new Date(dateInfo.date);
			const weekStart = this.getWeekStart(date);
			const weekKey = weekStart.toISOString().split('T')[0];

			if (!weeks[weekKey]) {
				weeks[weekKey] = [];
			}
			weeks[weekKey].push(dateInfo);
		});

		// Создаём календарные недели
		Object.keys(weeks).forEach(weekKey => {
			const weekEl = document.createElement('div');
			weekEl.className = 'popup-booking__week';

			weeks[weekKey].forEach(dateInfo => {
				const date = new Date(dateInfo.date);
				const dayEl = document.createElement('button');
				dayEl.type = 'button';
				dayEl.className = 'popup-booking__date';
				dayEl.dataset.date = dateInfo.date;

				const dayName = this.getDayName(date);
				const dayNum = date.getDate();
				const month = this.getMonthName(date);

				dayEl.innerHTML = `
					<span class="popup-booking__date-day">${dayName}</span>
					<span class="popup-booking__date-num">${dayNum}</span>
					<span class="popup-booking__date-month">${month}</span>
					<span class="popup-booking__date-slots">${dateInfo.slots_count} ${this.pluralize(dateInfo.slots_count, 'слот', 'слота', 'слотов')}</span>
				`;

				dayEl.addEventListener('click', () => this.selectDate(dateInfo.date, dayEl));
				weekEl.appendChild(dayEl);
			});

			container.appendChild(weekEl);
		});
	},

	/**
	 * Выбор даты
	 */
	selectDate: function(date, element) {
		// Убираем выделение с других дат
		document.querySelectorAll('.popup-booking__date').forEach(el => {
			el.classList.remove('popup-booking__date--selected');
		});

		// Выделяем выбранную
		element.classList.add('popup-booking__date--selected');

		// Сохраняем
		this.data.date = date;
		this.data.dateFormatted = this.formatDate(new Date(date));
		document.getElementById('booking-date').value = date;

		// Активируем кнопку "Далее"
		document.getElementById('booking-btn-next').disabled = false;
	},

	/**
	 * Загрузка доступных слотов времени с учётом формата
	 */
	loadAvailableSlots: function(personId, date, format) {
		const container = document.getElementById('booking-times');
		container.innerHTML = '<div class="popup-booking__loading"><div class="popup-booking__spinner"></div><span>Загрузка...</span></div>';

		const formData = new FormData();
		formData.append('mid', this.moduleId);
		formData.append('action', 'get_available_slots');
		formData.append('person_id', personId);
		formData.append('date', date);
		formData.append('format', format);

		fetch('/ajax.php', {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			if (data.success && data.slots && data.slots.length > 0) {
				this.availableSlots = data.slots;
				this.renderSlots(data.slots);
			} else {
				container.innerHTML = '<div class="popup-booking__empty">Нет доступного времени на эту дату</div>';
			}
		})
		.catch(error => {
			container.innerHTML = '<div class="popup-booking__error-message">Ошибка загрузки слотов</div>';
		});
	},

	/**
	 * Отрисовка слотов времени
	 */
	renderSlots: function(slots) {
		const container = document.getElementById('booking-times');
		container.innerHTML = '';

		const grid = document.createElement('div');
		grid.className = 'popup-booking__times-grid';

		slots.forEach(slot => {
			const slotEl = document.createElement('button');
			slotEl.type = 'button';
			slotEl.className = 'popup-booking__time';
			slotEl.dataset.start = slot.time_start;
			slotEl.dataset.end = slot.time_end;

			slotEl.innerHTML = `
				<span class="popup-booking__time-value">${slot.time_start}</span>
			`;

			slotEl.addEventListener('click', () => this.selectSlot(slot, slotEl));
			grid.appendChild(slotEl);
		});

		container.appendChild(grid);
	},

	/**
	 * Выбор слота времени
	 */
	selectSlot: function(slot, element) {
		// Убираем выделение с других слотов
		document.querySelectorAll('.popup-booking__time').forEach(el => {
			el.classList.remove('popup-booking__time--selected');
		});

		// Выделяем выбранный
		element.classList.add('popup-booking__time--selected');

		// Сохраняем
		this.data.timeStart = slot.time_start;
		this.data.timeEnd = slot.time_end;

		document.getElementById('booking-time-start').value = slot.time_start;
		document.getElementById('booking-time-end').value = slot.time_end;

		// Активируем кнопку "Далее"
		document.getElementById('booking-btn-next').disabled = false;
	},

	/**
	 * Переход к шагу
	 */
	goToStep: function(step) {
		this.currentStep = step;

		// Обновляем индикаторы шагов
		document.querySelectorAll('.popup-booking__step').forEach(el => {
			const stepNum = parseInt(el.dataset.step);
			el.classList.remove('popup-booking__step--active', 'popup-booking__step--completed');
			if (stepNum < step) {
				el.classList.add('popup-booking__step--completed');
			} else if (stepNum === step) {
				el.classList.add('popup-booking__step--active');
			}
		});

		// Показываем контент шага
		document.querySelectorAll('.popup-booking__step-content').forEach(el => {
			el.classList.remove('popup-booking__step-content--active');
		});
		document.getElementById('booking-step-' + step).classList.add('popup-booking__step-content--active');

		// Кнопки навигации
		const btnBack = document.getElementById('booking-btn-back');
		const btnNext = document.getElementById('booking-btn-next');
		const btnBook = document.getElementById('booking-btn-book');

		btnBack.style.display = step > 1 ? '' : 'none';

		if (step === 4) {
			btnNext.style.display = 'none';
			btnBook.style.display = '';

			// Обновляем сводку
			this.updateSummary();

			// Проверяем авторизацию
			this.checkAuth();
			const authRequired = document.getElementById('booking-auth-required');
			if (!this.isAuthenticated) {
				authRequired.style.display = '';
				btnBook.textContent = 'Войти и записаться';
			} else {
				authRequired.style.display = 'none';
				btnBook.textContent = 'Записаться';
			}
		} else {
			btnNext.style.display = '';
			btnBook.style.display = 'none';
			btnNext.disabled = true;
		}
	},

	/**
	 * Следующий шаг
	 */
	nextStep: function() {
		if (this.currentStep === 1) {
			// Проверяем выбор формата
			if (!this.data.format) {
				this.showError('Выберите формат консультации');
				return;
			}

			// Переходим к выбору даты
			this.goToStep(2);
			const formatText = this.data.format === 'онлайн' ? 'Онлайн' : 'Очно (10-я линия В.О., д. 59)';
			document.getElementById('booking-selected-format').textContent = formatText;
			this.loadAvailableDates(this.data.personId, this.data.format);

		} else if (this.currentStep === 2) {
			// Проверяем выбор даты
			if (!this.data.date) {
				this.showError('Выберите дату');
				return;
			}

			// Переходим к выбору времени
			this.goToStep(3);
			const formatText = this.data.format === 'онлайн' ? 'Онлайн' : 'Очно (10-я линия В.О., д. 59)';
			document.getElementById('booking-selected-format-2').textContent = formatText;
			document.getElementById('booking-selected-date').textContent = this.data.dateFormatted;
			this.loadAvailableSlots(this.data.personId, this.data.date, this.data.format);

		} else if (this.currentStep === 3) {
			// Проверяем выбор времени
			if (!this.data.timeStart) {
				this.showError('Выберите время');
				return;
			}

			// Переходим к подтверждению
			this.goToStep(4);
		}
	},

	/**
	 * Предыдущий шаг
	 */
	prevStep: function() {
		if (this.currentStep > 1) {
			this.goToStep(this.currentStep - 1);

			// Восстанавливаем активность кнопки "Далее" если данные уже выбраны
			if (this.currentStep === 1 && this.data.format) {
				document.getElementById('booking-btn-next').disabled = false;
			} else if (this.currentStep === 2 && this.data.date) {
				document.getElementById('booking-btn-next').disabled = false;
			} else if (this.currentStep === 3 && this.data.timeStart) {
				document.getElementById('booking-btn-next').disabled = false;
			}
		}
	},

	/**
	 * Применить промокод
	 */
	applyPromo: function() {
		var code = document.getElementById('booking-promo-code').value.trim();
		var resultEl = document.getElementById('booking-promo-result');
		if (!code) {
			resultEl.innerHTML = '<span style="color:#c0392b;">Введите промокод</span>';
			return;
		}

		var price = this.data.price || this.data.servicePrice;
		var formData = new FormData();
		formData.append('mid', this.moduleId);
		formData.append('action', 'check_promo');
		formData.append('promo_code', code);
		formData.append('price', price);

		fetch('/ajax.php', { method: 'POST', body: formData })
			.then(function(r) { return r.json(); })
			.then(function(data) {
				if (data.success) {
					Booking.data.promoCode = code;
					Booking.data.promoDiscount = data.discount;
					Booking.data.finalPrice = data.new_price;
					resultEl.innerHTML = '<span style="color:#27ae60;">Скидка ' + Booking.formatPrice(data.discount) + ' ₽</span>';
					document.getElementById('booking-confirm-price').innerHTML =
						'<s style="color:#999;font-size:0.85em;">' + Booking.formatPrice(price) + ' ₽</s> ' +
						Booking.formatPrice(data.new_price) + ' ₽';
				} else {
					Booking.data.promoCode = null;
					Booking.data.promoDiscount = 0;
					Booking.data.finalPrice = null;
					resultEl.innerHTML = '<span style="color:#c0392b;">' + (data.error || 'Промокод недействителен') + '</span>';
				}
			});
	},

	/**
	 * Обновление сводки перед подтверждением
	 */
	updateSummary: function() {
		document.getElementById('booking-confirm-psy').textContent = this.data.personName;
		document.getElementById('booking-confirm-service').textContent = this.data.serviceName || 'Индивидуальная консультация';
		document.getElementById('booking-confirm-format').textContent = this.data.format === 'онлайн' ? 'Онлайн (видеоконференция)' : 'Очно (Институт «Иматон», 10-я линия В.О., д. 59)';
		document.getElementById('booking-confirm-date').textContent = this.data.dateFormatted;
		document.getElementById('booking-confirm-time').textContent = this.data.timeStart + ' — ' + this.data.timeEnd;
		document.getElementById('booking-confirm-price').textContent = this.formatPrice(this.data.price || this.data.servicePrice) + ' ₽';
	},

	/**
	 * Показать авторизацию и затем записать
	 */
	showAuthAndBook: function() {
		// Закрываем попап записи (но сохраняем данные)
		this.close();

		// Открываем попап авторизации
		if (window.Auth) {
			Auth.openAuthPopup();

			// Подписываемся на успешную авторизацию
			const onAuth = () => {
				document.removeEventListener('authSuccess', onAuth);
				this.isAuthenticated = true;

				// Возобновляем запись
				setTimeout(() => {
					const popup = document.getElementById('popup-booking');
					if (popup) {
						popup.classList.add('active');
						document.body.style.overflow = 'hidden';
					}
					this.goToStep(4);
				}, 500);
			};

			document.addEventListener('authSuccess', onAuth);
		}
	},

	/**
	 * Создание записи
	 */
	createBooking: function() {
		// Проверяем авторизацию
		if (!this.isAuthenticated) {
			this.showAuthAndBook();
			return;
		}

		// Проверяем заполнение комментария
		var notesEl = document.getElementById('booking-notes');
		if (notesEl && !notesEl.value.trim()) {
			notesEl.classList.add('popup-booking__notes-input--error');
			this.showError('Пожалуйста, опишите коротко, что Вас беспокоит');
			notesEl.focus();
			return;
		}
		if (notesEl) notesEl.classList.remove('popup-booking__notes-input--error');

		// Проверяем согласие с офертой
		var ofertaCheckbox = document.getElementById('booking-oferta');
		if (ofertaCheckbox && !ofertaCheckbox.checked) {
			this.showError('Необходимо согласиться с условиями оферты');
			return;
		}

		const btnBook = document.getElementById('booking-btn-book');
		btnBook.disabled = true;
		btnBook.textContent = 'Создание записи...';

		this.clearError();

		const formData = new FormData();
		formData.append('mid', this.moduleId);
		formData.append('action', 'create_booking');
		formData.append('person_id', this.data.personId);
		formData.append('service_id', this.data.serviceId || '');
		formData.append('date', this.data.date);
		formData.append('time_start', this.data.timeStart);
		formData.append('time_end', this.data.timeEnd);
		formData.append('format', this.data.format);
		formData.append('notes', document.getElementById('booking-notes').value);
		if (this.data.promoCode) {
			formData.append('promo_code', this.data.promoCode);
		}

		fetch('/ajax.php', {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			if (data.success) {
				this.onBookingSuccess(data);
			} else if (data.need_profile) {
				// Профиль не заполнен — показываем попап заполнения
				this.close();
				if (typeof Auth !== 'undefined' && Auth.showProfileComplete) {
					Auth.showProfileComplete();
				} else {
					window.location.href = '/profile/';
				}
			} else {
				this.showError(data.error || 'Ошибка создания записи');
				btnBook.disabled = false;
				btnBook.textContent = 'Записаться';
			}
		})
		.catch(error => {
			console.error('Booking error:', error);
			this.showError('Ошибка соединения');
			btnBook.disabled = false;
			btnBook.textContent = 'Записаться';
		});
	},

	/**
	 * Успешное создание записи
	 */
	onBookingSuccess: function(data) {
		// Показываем сообщение об успехе
		const content = document.querySelector('.popup-booking__content');
		content.innerHTML = `
			<div class="popup-booking__success">
				<div class="popup-booking__success-icon">✓</div>
				<div class="popup-booking__success-title">Запись создана!</div>
				<div class="popup-booking__success-text">
					<p>Вы записаны к психологу ${this.data.personName}</p>
					<p><strong>${this.data.dateFormatted}</strong> в <strong>${this.data.timeStart}</strong></p>
					<p>Формат: ${this.data.format === 'онлайн' ? 'онлайн' : 'очно'}</p>
				</div>
				${data.need_payment ? `
					<div class="popup-booking__success-payment">
						<p>Для подтверждения записи оплатите консультацию:</p>
						<a href="${data.payment_url}" class="popup-booking__btn popup-booking__btn--primary">Оплатить ${this.formatPrice(this.data.finalPrice || this.data.price || this.data.servicePrice)} ₽</a>
					</div>
				` : `
					<div class="popup-booking__success-info">
						<p>Мы отправили подтверждение на ваш номер телефона.</p>
					</div>
				`}
				<button class="popup-booking__btn popup-booking__btn--secondary" onclick="Booking.close()">Закрыть</button>
			</div>
		`;

		// Скрываем кнопки навигации
		document.querySelector('.popup-booking__actions').style.display = 'none';

		// Событие для других компонентов
		document.dispatchEvent(new CustomEvent('bookingSuccess', { detail: data }));

		if (window.Lead) Lead.reachGoal('booking_complete');
	},

	/**
	 * Показать ошибку
	 */
	showError: function(message) {
		const errorEl = document.getElementById('booking-error');
		if (errorEl) {
			errorEl.textContent = message;
			errorEl.style.display = '';
		}
	},

	/**
	 * Очистить ошибку
	 */
	clearError: function() {
		const errorEl = document.getElementById('booking-error');
		if (errorEl) {
			errorEl.textContent = '';
			errorEl.style.display = 'none';
		}
	},

	// === Вспомогательные функции ===

	getWeekStart: function(date) {
		const d = new Date(date);
		const day = d.getDay();
		const diff = d.getDate() - day + (day === 0 ? -6 : 1);
		return new Date(d.setDate(diff));
	},

	getDayName: function(date) {
		const days = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
		return days[date.getDay()];
	},

	getMonthName: function(date) {
		const months = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
		return months[date.getMonth()];
	},

	formatDate: function(date) {
		const day = date.getDate();
		const months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
		const month = months[date.getMonth()];
		const weekdays = ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'];
		const weekday = weekdays[date.getDay()];
		return day + ' ' + month + ', ' + weekday;
	},

	formatPrice: function(price) {
		return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
	},

	pluralize: function(n, one, few, many) {
		n = Math.abs(n) % 100;
		const n1 = n % 10;
		if (n > 10 && n < 20) return many;
		if (n1 > 1 && n1 < 5) return few;
		if (n1 === 1) return one;
		return many;
	}
};

// Автоинициализация
document.addEventListener('DOMContentLoaded', function() {
	Booking.init();
});

// Экспорт в глобальную область
window.Booking = Booking;
